export default "__VITE_ASSET__01ec0d13__"